export default __webpack_public_path__ + "df95803307e2749fa81fa46dcff15381.png";